import React from 'react';
import { Divider, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ProfileMenuItemProps } from '../types/ProfileMenu.types';


const ProfileMenuItem: React.FC<ProfileMenuItemProps> = ({ icon, label, onClick, hasDivider = false, styleSx }) => (
    <>
        <ListItemButton sx={{ pt: 0.5, pb: 0.5, ...styleSx }} onClick={onClick}>
            <ListItemIcon sx={{ minWidth: '43px' }}>{icon}</ListItemIcon>
            <ListItemText primary={label} />
        </ListItemButton>
        {hasDivider && <Divider variant="middle" component="li" />}
    </>
);

export default ProfileMenuItem;
